/** Props par défaut pour les blocs avec média. */
export const defaultMediaPuckProps = {
  mediaFit: 'cover',
  mediaAspectRatio: 'auto',
};

export const puckMediaFitField = {
  type: 'radio',
  label: 'Affichage du média',
  options: [
    { label: 'Remplir (recadrer)', value: 'cover' },
    { label: 'Contenir (ajuster)', value: 'contain' },
  ],
};

export const puckMediaAspectRatioField = {
  type: 'select',
  label: 'Format du média',
  options: [
    { label: 'Auto (fichier)', value: 'auto' },
    { label: '16:9', value: '16/9' },
    { label: '21:9', value: '21/9' },
    { label: '4:3', value: '4/3' },
    { label: '1:1', value: '1/1' },
  ],
};

/** Même liste de formats, sans « Auto » : pour un cadre dont le format est imposé (comparateur, visuel du déroulé). */
export const puckFixedAspectRatioField = (label = puckMediaAspectRatioField.label) => ({
  ...puckMediaAspectRatioField,
  label,
  options: puckMediaAspectRatioField.options.filter(({ value }) => value !== 'auto'),
});

/** Champs Puck réutilisables (fit + ratio). */
export function puckMediaFields() {
  return {
    mediaFit: puckMediaFitField,
    mediaAspectRatio: puckMediaAspectRatioField,
  };
}
